import Box from 'Components/Atoms/Box';
import Button from 'Components/Atoms/Button';
import { Block, CheckCircle, LockOpen } from 'Components/Atoms/Icons';
import { useReservationContext } from 'Contexts/ReservationContext';
import React from 'react';
import { dateHelper } from 'utils/helper';

export type TableButtonsProps = {
  onWalkin: (tables: string[], space?: string) => void;
  onToggleBlock: (id: string, name: string) => void;
  blocked: boolean;
  id: string;
  name: string;
  space?: string;
  /** Show the second button that opens the per-shift dialog. */
  perShiftBlocking?: boolean;
  onOpenBlockModal?: () => void;
};

const TableButtons = ({
  onWalkin,
  blocked,
  onToggleBlock,
  id,
  name,
  space,
  perShiftBlocking = false,
  onOpenBlockModal,
}: TableButtonsProps) => {
  const { date } = useReservationContext();

  return (
    <Box
      padding={10}
      className="flex-column"
      background
      style={{
        backgroundColor: 'var(--color-paper)',
        zIndex: 102,
      }}
    >
      <Button
        fullWidth
        endIcon={() => <CheckCircle color="primary" />}
        typographyProps={{
          variant: 'text-2',
          style: { marginRight: 8 },
        }}
        onClick={() => onWalkin([name], space)}
        translation="reservations"
        style={{ border: '1px solid var(--color-border)' }}
        disabled={date !== dateHelper()}
      >
        Walk in
      </Button>
      <Box style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 16 }}>
        {blocked ? (
          <Button
            fullWidth
            variant="outlined"
            style={{ borderColor: 'var(--color-primary)' }}
            color="primary"
            endIcon={() => <LockOpen fontSize="small" />}
            typographyProps={{
              variant: 'text-2',
              color: 'primary',
              style: { marginRight: 8 },
            }}
            onClick={() => onToggleBlock(id, name)}
            translation="reservations"
          >
            Unblock Table
          </Button>
        ) : (
          <Button
            fullWidth
            variant="outlined"
            style={{
              color: 'var(--color-critical)',
              borderColor: 'var(--color-critical)',
            }}
            endIcon={() => <Block fontSize="small" />}
            typographyProps={{
              variant: 'text-2',
              style: { color: 'var(--color-critical)', marginRight: 8 },
            }}
            onClick={() => onToggleBlock(id, name)}
            translation="reservations"
          >
            Block Table
          </Button>
        )}
        {perShiftBlocking && (
          <Button
            fullWidth
            variant="outlined"
            style={{ borderColor: 'var(--color-border)' }}
            // No icon: "Tisch für Schicht blockieren" only fits one line without it.
            typographyProps={{ variant: 'text-2' }}
            onClick={onOpenBlockModal}
            translation="reservations"
          >
            Block by shift
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default TableButtons;
